import { Component, OnInit } from '@angular/core';
import { StateService } from 'ui-router-core';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.css']
})
export class NewsComponent implements OnInit {


  constructor() { }

  ngOnInit() {
    
  }

}



// WEBPACK FOOTER //
// ./src/app/news/news/news.component.ts